<template>
    <div class="ipoint-topup-group">
        <Spin size="large" fix v-if="spinShow"></Spin>
        <div class="ipoint-topup ipoint-payment">
            <div class="ipoint-topup-type">
                <a class="number-topup"  v-for="(item,index) in tabs"
                     :class="{active:index == num,'clear_border':index === 1}"
                     @click="tab(index)" >{{item.type}}</a>
            </div>
            <div class="ipoint-topup-group">
                <div class="ipoint-topup-group-ss" v-if="this.current == 0">
                    <div class="ipoint-number-group" >
                        <label  @click="selectNumber(item.ipoint)" v-for="item in nums">
                            <button type="button" v-bind:class="{active:total == item.ipoint}" style="position: relative;padding: 20px 0;">
                                <div style="position: absolute;top:0;right: -7px;width: 75px;display: flex;justify-content: center" v-if="item.if_special===1">
                                    <img src="../../../assets/label_activity@2x.png" style="width: 100%;height: 30px;">
                                    <p style="position: absolute;top: 0;font-size: 12px;color:white;">{{$t('top_msg')}}</p>
                                </div>
                                <p style="font-size: 30px;">${{item.money}}</p>
                                <p style="font-size: 16px;">{{item.ipoint}} iPoint</p>
                                <p style="width:100%;font-size: 14px;background:#009aff;color: white;position: absolute;bottom: 0">{{item.msg}}</p>
                            </button>
                        </label>
                        <label style="padding:0;"><input type="hidden" placeholder="5" v-model="total"  readonly="readonly" ></label>
                        <br>
                        <p v-for="item in nums" v-html="item.special_msg" style="text-align: left;font-size: 12px;line-height: 20px;"  v-if="item.ipoint === total"></p>
                    </div>
                </div>

                <div class="payment-group top_up_card" v-else>
                    <div class="form-group" style="display: block;">
                        <p class="pay-tips-title">
                            {{$t('top_up_tips')}}
                        </p>
                        <p class="pay-tips-s">
                            {{$t('top_up_tips1')}}
                        </p>
                        <div class="form-input">
                            <input type="text" class="top_up_input"
                                   :placeholder="$t('user_center_iPoint_topup_card_num')"
                                   v-validate="'required'"
                                   name="ipoint_top_up_card_no"
                                   v-model="car.number"
                                   :class="{'is-error': errors.has('ipoint_top_up_card_no')}">
                        </div>
                    </div>
                    <div class="form-group" style="display: block;">
                        <div class="form-input">
                            <input type="text" class="top_up_input"
                                   :placeholder="$t('user_center_iPoint_topup_code')"
                                   v-validate="'required'"
                                   v-model="car.pwd"
                                   name="ipoint_top_up_card_code"
                                   :class="{'is-error': errors.has('ipoint_top_up_card_code')}"
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="ipoint-payment-group" v-if="this.current == 0" >
                <label class="profile-radio" @click="checkRadio(1,$event)">
                    <span class="pro-radio" v-bind:class="{'pro-radio-checked':flag==1}">
                        <span class="pro-radio-inner"></span>
                        <input type="radio" class="pro-radio-input">
                    </span>
                    <div class="payment-group payment-group-paypal">
                        <button type="button" class="payment-icon" >
                            <img src="../../../assets/profile/visa.jpg" alt="" width="88">
                        </button>
                    </div>
                </label>

                <label class="profile-radio" @click="checkRadio(5,$event)">
                    <span class="pro-radio" v-bind:class="{'pro-radio-checked':flag==5}">
                    <span class="pro-radio-inner"></span>
                        <input type="radio" class="pro-radio-input">
                    </span>
                    <div class="payment-group payment-group-paypal">
                    <button type="button" class="payment-icon">
                        <img src="../../../assets/profile/paypal.png" alt="">
                    </button>
                    </div>
                </label>

                <!--<label class="profile-radio" @click="checkRadio(4,$event)">-->
                    <!--<span class="pro-radio" v-bind:class="{'pro-radio-checked':flag==4}">-->
                    <!--<span class="pro-radio-inner"></span>-->
                        <!--<input type="radio" class="pro-radio-input">-->
                    <!--</span>-->
                    <!--<div class="payment-group payment-group-paypal">-->
                        <!--<button type="button" class="payment-icon">-->
                            <!--<img src="../../../assets/profile/alipay.jpg" alt="">-->
                        <!--</button>-->
                    <!--</div>-->
                <!--</label>-->

                <p class="pay-tips">{{$t('user_order_pay_tips')}}</p>
                <div class="pay-subtotal">
                    <div class="sub-total">
                        {{$t('user_center_order_Subtotal')}}: <span class="text-primary">USD ${{payTotal}}</span>
                        <Button type="primary" @click="checkOut">{{$t('check_out_btn')}}</Button>
                    </div>
                    <p class="pay-tips">(1USD=100iPoint)</p>
                </div>
            </div>
            <div class="ipoint-payment-group" v-else>
                <div class="pay-subtotal">
                    <div class="pay-subtotal-group-s">
                        <Button class="topup_card_btn" type="primary" @click="topup_card">{{$t('check_out_btn')}}</Button>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import Signature from '../../../lib/Signature'
    import PayType from '../../../lib/PayType'

    export default {
        data () {
            return {
                nums: [500, 1000, 2000, 2500, 5000, 8000],
                vertical: 'recharge',
                flag: PayType.VISA,
                total: 0,
                inputNumber: 0,
                current:0,
                spinShow:false,
                webWidth_num:'',
                num:0,
                html: '',
                car: {
                    pwd: '',
                    number: ''
                },
                tabs: [
                    {
                        type:this.$t('top_up_tab1')
                    },
                    {
                        type:this.$t('user_center_iPoint_topup_card_num_topup')
                    }
                ]
            }
        },
        methods: {
            webWidth() {
                this.webWidth_num = document.body.clientWidth
            },
            topup_card(){
                if (this.car.number === '') {
                    this.$Message.error(this.$t('top_up_null'))
                    return false
                } else if (this.car.pwd === '') {
                    this.$Message.error(this.$t('top_up_null1'))
                    return false
                }
                let module = 'index.php/cardtopup'
                let data = {}
                data.car_number = this.car.number
                data.car_pwd = this.car.pwd
                data.token = this.Local.getUserToken()
                data.user_id = this.Local.getUserId()
                data.sub_time = Signature.timestamp()
                data.lang = this.$i18n.locale
                data.sign = Signature.create(module, data.sub_time)
                this.spinShow = true
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        resp.data.code = parseInt(resp.data.code)
                        if (resp.data.code === 2000) {
                            this.spinShow = false
                            this.$Message.success(this.$t('user_center_iPoint_topup_Recharge_suceess'))
                            this.$router.push({
                                name: 'iPointSuccess'
                            })
                        } else {
                            this.spinShow = false
                            this.$Message.error(resp.data.msg)
                        }
                    }.bind(this))
            },
            tab (index) {
                this.num = index
                this.current = index
            },
            checkOut () {
                if (this.flag === 1 || this.flag === 5 || this.flag === 4) {
                    if (this.total === 0) {
                        this.$Message.error(this.$t('user_center_iPoint_topup_choose_money'))
                        return false
                    }
                }
                let module = 'index.php/index/pay/topup'
                let data = {}
                data.token = this.Local.getUserToken()
                data.user_id = this.Local.getUserId()
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                data.ipoint = this.total
                data.type = this.flag
                data.redirect_url = 'http://' + window.location.host + '/#/ipoint-success'
                data.redirect_error_url = data.redirect_url
                if(this.webWidth_num > 768){
                    data.web_type = 1
                }else{
                    data.web_type = 2
                }
                this.spinShow = true
                this.$http.post(process.env.BASEURL + module, data)
                .then(function (resp) {
                    resp.data.code = parseInt(resp.data.code)
                    if (resp.data.code === 2000) {
                        this.spinShow = false
                        console.log(resp.data)
                        if (this.flag === 1 || this.flag === 5 || this.flag === 4) {
                            window.location.href = resp.data.data.notify_url
                        }
                    } else {
                        this.spinShow = false
                        this.$Message.error(resp.data.msg)
                    }
                }.bind(this))
            },
            checkRadio (index, e) {
                this.flag = index
                if (e.target.nodeName === 'INPUT') {
                    this.flag = index
                }
            },
            selectNumber (index) {
                this.total = index
            },
            fetchData () {
                let module = 'index.php/index/ipoint/special_list'
                let data = {}
                data.token = this.Local.getUserToken()
                data.user_id = this.Local.getUserId()
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                }).then(function (response) {
                    if (parseInt(response.data.msg) === 2000) {
                        this.nums = response.data.data
                        console.log(response.data.data)
                    }
                }.bind(this))
            }
        },
        computed: {
            payTotal () {
                return this.total / 100
            }
        },

        created () {
            this.fetchData()
            //网页宽度
            this.webWidth()
        }
    }
</script>
<style lang="scss">
    @import "../../../scss/personal/topup";
</style>



// WEBPACK FOOTER //
// TopUp.vue?06f9d9ce